import toast from "react-hot-toast";
import type { NavigateFunction } from "react-router-dom";
import type { RejectPayload } from "./ApiError";

interface ThunkResultLike {
  payload?: RejectPayload;
  error?: {
    message?: string;
    name?: string;
  };
  meta?: {
    aborted?: boolean;
  };
}

interface HandleRequestErrorOptions {
  navigate?: NavigateFunction;
  fallbackMessage?: string;
  on403?: "back" | "ignore";
  showToast?: boolean;
}

export function isAborted(result: ThunkResultLike): boolean {
  return Boolean(result.meta?.aborted) || result.error?.name === "AbortError";
}

export function handleRequestError(
  error: RejectPayload,
  options: HandleRequestErrorOptions = {},
): void {
  const {
    navigate,
    fallbackMessage = "Terjadi kesalahan, silakan coba lagi.",
    on403 = "ignore",
  } = options;

  toast.error(error.message || fallbackMessage);

  if (error.status === 503) {
    navigate?.("/service-unavailable", { replace: true });
    return;
  }

  if (error.status === 403 && on403 === "back") {
    navigate?.(-1);
    return;
  }
}

export function handleThunkError(
  result: ThunkResultLike,
  options: HandleRequestErrorOptions = {},
): void {
  if (isAborted(result)) {
    return;
  }

  handleRequestError(
    {
      message:
        result.payload?.message ||
        result.error?.message ||
        options.fallbackMessage ||
        "Terjadi kesalahan, silakan coba lagi.",
      status: result.payload?.status,
    },
    options,
  );
}
